import $catch from './$catch';
import appApi from '@/api/app';


// eslint-disable-next-line import/no-anonymous-default-export
export default {

    /*
    @name loginOut
    @desc 系统退出方法
    */
    loginOut(props) {
        return new Promise((resolve) => {
            this.loginOutHref(props);
            resolve(true);
            // appApi.loginOut(null, null, { isMessage: false })
            //     .then(() => {
            //         //清空缓存，退出系统
            //         this.loginOutHref();
            //         resolve(true);
            //     });
        })
    },


    /*
    @name loginOutHref
    @desc 系统退出跳转方法
    */
    loginOutHref(props) {
        $catch.clearSessionAll();
        window.history.replaceState(null,null,"#/login")
        window.location.reload()
        //window.location.href = '#/';
    },

};
